
// import { useState, useEffect } from 'react';
// import { NavLink, useLocation, useNavigate } from 'react-router-dom';
// import { FaCreditCard, FaUser, FaUserFriends, FaUsers, FaUserTie } from "react-icons/fa";
// import { FaFileAlt } from "react-icons/fa";
// import { IoMdSettings } from "react-icons/io";
// import { BiSpreadsheet, BiTask } from "react-icons/bi";
// import { FaBars } from "react-icons/fa6";
// import { IoClose } from "react-icons/io5";
// import { IoDocumentsSharp } from "react-icons/io5";
// import { Menu } from 'antd';
// import { LoginOutlined } from '@ant-design/icons';
// import { MdCoPresent, MdDashboard } from "react-icons/md";
// import { LiaUserCogSolid } from "react-icons/lia";
// import { Timesheetapi } from "../../middleware/interceptor";

// export const Sidebar = ({ Emp_role, setsidebor }) => {
//   const location = useLocation();

//   const [isDrawerOpen, setIsDrawerOpen]   = useState(true);
//   const [activeKey, setActiveKey]         = useState('');
//   const [permissions, setPermissions]     = useState({});   // { dashboard: true, activity_card: true, ... }
//   const [permLoading, setPermLoading]     = useState(true);

//   // ── 1. Fetch permissions once on mount ───────────────────────────────
//   useEffect(() => {
//     const fetchPermissions = async () => {
//       try {
//         const empRoleId = localStorage.getItem('emp_role_id');
//         if (!empRoleId) return;

//         const response = await Timesheetapi.get(
//           `api/Roles/GetPermissionsByRoleId?roleId=${empRoleId}`
//         );

//         // Build a quick lookup: { module_key: has_access (bool) }
//         const map = {};
//         (response.data?.permissions || []).forEach(p => {
//           map[p.module_key] = !!p.has_access;
//         });
//         setPermissions(map);
//       } catch (err) {
//         console.error("Failed to load sidebar permissions:", err);
//       } finally {
//         setPermLoading(false);
//       }
//     };

//     fetchPermissions();
//   }, []);

//   // ── 2. Active key based on URL ────────────────────────────────────────
//   useEffect(() => {
//     const path = location.pathname;
//     if      (path.includes('/dashboard'))          setActiveKey('dashboard');
//     else if (path.includes('/timesheets'))         setActiveKey('activity_card');
//     else if (path.includes('/my-workitems'))       setActiveKey('my_activities');
//     else if (path.includes('/teams-activities'))   setActiveKey('teams_activities');
//     else if (path.includes('/Approvals'))          setActiveKey('approvals');
//     else if (path.includes('/reports'))            setActiveKey('reports');
//     else if (path.includes('Settings/Clients'))    setActiveKey('clients');
//     else if (path.includes('Settings/projects'))   setActiveKey('projects');
//     else if (path.includes('/users'))              setActiveKey('users');
//     else if (path.includes('/role'))               setActiveKey('role');
//     else if (path.includes('/Logins/LoginInfo'))   setActiveKey('logins');
//     else if (path.includes('/employee'))           setActiveKey('employee');
//     else if (path.includes('/Clients'))            setActiveKey('clients');
//     else if (path.includes('/projects'))           setActiveKey('projects');
//     else if (path.includes('/employeerate'))       setActiveKey('employeerate');
//   }, [location.pathname]);

//   useEffect(() => {
//     setsidebor(isDrawerOpen);
//   }, [isDrawerOpen]);

//   // ── Helper: only render if permission granted ─────────────────────────
//   const can = (key) => !!permissions[key];

//   // ── 3. Determine if Settings submenu should show ──────────────────────
//   // Settings submenu appears when at least one sub-item (clients/projects/users/role) is accessible
//   const showSettings = can('settings');

//   if (permLoading) {
//     return (
//       <aside
//         className="max-w-[225px] bg-[#fff] text-white flex flex-col items-center py-10"
//         style={{ borderRight: '1px solid #cfcfcf' }}
//       >
//         <div className="text-gray-400 text-[12px] mt-4">Loading...</div>
//       </aside>
//     );
//   }

//   return (
//     <aside
//       className="max-w-[225px] bg-[#fff] text-white flex flex-col items-center py-10"
//       style={{ borderRight: '1px solid #cfcfcf' }}
//     >
//       {/* Logo + Toggle */}
//       <div className='flex justify-between w-[100%] px-3 gap-4'>
//         <button
//           className='flex items-center justify-center rounded-[5px] h-[30px] w-[30px] bg-[#fff] border border-[#3b82f6]'
//           onClick={() => setIsDrawerOpen(!isDrawerOpen)}
//         >
//           {isDrawerOpen
//             ? <IoClose className='text-[20px] text-[#3b82f6]' />
//             : <FaBars  className='text-[18px] text-[#3b82f6]' />
//           }
//         </button>
//         <img
//           className={`side-logo1 relative top-[-8px] ${isDrawerOpen ? '' : 'hidden'}`}
//           src='https://jetzerp.s3.us-east-1.amazonaws.com/images/primary_logo.svg'
//           alt="logo"
//         />
//         <img
//           className={`side-logo2 ${isDrawerOpen ? 'hidden' : ''}`}
//           src='https://jetzerp.s3.us-east-1.amazonaws.com/images/favicon.ico'
//           alt="logo"
//         />
//       </div>

//       {/* ── EXPANDED MENU ── */}
//       {isDrawerOpen ? (
//         <ul className="w-full mt-[1.5rem]">
//           <Menu
//             mode="inline"
//             theme="light"
//             selectedKeys={[activeKey]}
//             onClick={({ key }) => setActiveKey(key)}
//           >
//             {/* Dashboard */}
//             {can('dashboard') && (
//               <Menu.Item key="dashboard" icon={<MdDashboard style={{ fontSize: '20px' }} />}>
//                 <NavLink to="/dashboard">Dashboard</NavLink>
//               </Menu.Item>
//             )}

//             {/* Activity Card */}
//             {can('activity_card') && (
//               <Menu.Item key="activity_card" icon={<BiSpreadsheet style={{ fontSize: '18px' }} />}>
//                 <NavLink to="/timesheets">Activity Card</NavLink>
//               </Menu.Item>
//             )}

//             {/* My Activities */}
//             {can('my_activities') && (
//               <Menu.Item key="my_activities" icon={<BiTask style={{ fontSize: '18px' }} />}>
//                 <NavLink to="/my-workitems">My Activities</NavLink>
//               </Menu.Item>
//             )}

//             {/* Teams Activities */}
//             {can('teams_activities') && (
//               <Menu.Item key="teams_activities" icon={<FaUsers style={{ fontSize: '18px' }} />}>
//                 <NavLink to="/teams-activities">Teams Activities</NavLink>
//               </Menu.Item>
//             )}

//             {/* Approvals */}
//             {can('approvals') && (
//               <Menu.Item key="approvals" icon={<BiTask style={{ fontSize: '18px' }} />}>
//                 <NavLink to="/Approvals">Approvals</NavLink>
//               </Menu.Item>
//             )}

//             {/* Reports */}
//             {can('reports') && (
//               <Menu.Item key="reports" icon={<IoDocumentsSharp style={{ fontSize: '18px' }} />}>
//                 <NavLink to="/reports">Reports</NavLink>
//               </Menu.Item>
//             )}

//             {/* Settings submenu — only if settings permission exists */}
//             {showSettings && (
//               <Menu.SubMenu
//                 key="sub_settings"
//                 icon={<IoMdSettings style={{ fontSize: '19px' }} />}
//                 title={<span className="menu-title">Settings</span>}
//               >
//                 {can('clients') && (
//                   <Menu.Item key="clients" icon={<FaUserTie style={{ fontSize: '15px' }} />}>
//                     <NavLink to="Settings/Clients">Clients</NavLink>
//                   </Menu.Item>
//                 )}
//                 {can('projects') && (
//                   <Menu.Item key="projects" icon={<FaFileAlt style={{ fontSize: '15px' }} />}>
//                     <NavLink to="Settings/projects">Projects</NavLink>
//                   </Menu.Item>
//                 )}
//                 {can('users') && (
//                   <Menu.Item key="users" icon={<FaUser style={{ fontSize: '15px' }} />}>
//                     <NavLink to="users">Users</NavLink>
//                   </Menu.Item>
//                 )}
//                 {can('role') && (
//                   <Menu.Item key="role" icon={<LiaUserCogSolid style={{ fontSize: '18px' }} />}>
//                     <NavLink to="role">Role</NavLink>
//                   </Menu.Item>
//                 )}
//               </Menu.SubMenu>
//             )}

//             {/* ── Items below are NOT in permissions table — kept as-is ── */}

//             {/* Logins (role 4 & 5 only — not in permissions table, keep hardcoded) */}
//             {(localStorage.getItem('emp_role_id') == 4 || localStorage.getItem('emp_role_id') == 5) && (
//               <Menu.SubMenu
//                 key="sub_logins"
//                 icon={<MdCoPresent style={{ fontSize: '16px' }} />}
//                 title={<span className="menu-title">Logins</span>}
//               >
//                 <Menu.Item key="logins" icon={<LoginOutlined style={{ fontSize: '18px' }} />}>
//                   <NavLink to="/Logins/LoginInfo">Login Info</NavLink>
//                 </Menu.Item>
//               </Menu.SubMenu>
//             )}

//             {/* Employee (role 5 only) */}
//             {localStorage.getItem('emp_role_id') == 5 && (
//               <>
//                 <Menu.Item key="employee" icon={<FaUserFriends style={{ fontSize: '18px' }} />}>
//                   <NavLink to="/employee">Employee</NavLink>
//                 </Menu.Item>
//                 <Menu.Item key="employeerate" icon={<FaCreditCard className="text-[16px]" />}>
//                   <NavLink to="/employeerate">Rate Card</NavLink>
//                 </Menu.Item>
//               </>
//             )}

//           </Menu>
//         </ul>

//       ) : (
//         /* ── COLLAPSED ICON-ONLY MENU ── */
//         <ul className="w-full mt-[1.5rem]">
//           <Menu
//             className="custom-menu"
//             mode="inline"
//             theme="light"
//             selectedKeys={[activeKey]}
//             onClick={({ key }) => setActiveKey(key)}
//           >
//             {can('dashboard') && (
//               <Menu.Item key="dashboard">
//                 <NavLink to="/dashboard"><MdDashboard style={{ fontSize: '20px' }} /></NavLink>
//               </Menu.Item>
//             )}
//             {can('activity_card') && (
//               <Menu.Item key="activity_card">
//                 <NavLink to="/timesheets"><BiSpreadsheet style={{ fontSize: '18px' }} /></NavLink>
//               </Menu.Item>
//             )}
//             {can('my_activities') && (
//               <Menu.Item key="my_activities">
//                 <NavLink to="/my-workitems"><BiTask style={{ fontSize: '18px' }} /></NavLink>
//               </Menu.Item>
//             )}
//             {can('teams_activities') && (
//               <Menu.Item key="teams_activities">
//                 <NavLink to="/teams-activities"><FaUsers style={{ fontSize: '18px' }} /></NavLink>
//               </Menu.Item>
//             )}
//             {can('approvals') && (
//               <Menu.Item key="approvals">
//                 <NavLink to="/Approvals"><BiTask style={{ fontSize: '18px' }} /></NavLink>
//               </Menu.Item>
//             )}
//             {can('reports') && (
//               <Menu.Item key="reports">
//                 <NavLink to="/reports"><IoDocumentsSharp className="text-[20px]" /></NavLink>
//               </Menu.Item>
//             )}
//             {showSettings && (
//               <Menu.SubMenu
//                 key="sub_settings"
//                 icon={<IoMdSettings style={{ fontSize: '19px', position: 'relative', left: '13px' }} />}
//               >
//                 {can('clients') && (
//                   <Menu.Item key="clients">
//                     <NavLink to="Settings/Clients"><FaUserTie style={{ fontSize: '15px' }} /></NavLink>
//                   </Menu.Item>
//                 )}
//                 {can('projects') && (
//                   <Menu.Item key="projects">
//                     <NavLink to="Settings/projects"><FaFileAlt style={{ fontSize: '15px' }} /></NavLink>
//                   </Menu.Item>
//                 )}
//                 {can('users') && (
//                   <Menu.Item key="users">
//                     <NavLink to="users"><FaUser style={{ fontSize: '15px' }} /></NavLink>
//                   </Menu.Item>
//                 )}
//                 {can('role') && (
//                   <Menu.Item key="role">
//                     <NavLink to="role"><LiaUserCogSolid style={{ fontSize: '18px' }} /></NavLink>
//                   </Menu.Item>
//                 )}
//               </Menu.SubMenu>
//             )}
//             {(localStorage.getItem('emp_role_id') == 4 || localStorage.getItem('emp_role_id') == 5) && (
//               <Menu.SubMenu
//                 key="sub_logins"
//                 icon={<MdCoPresent style={{ fontSize: '18px', position: 'relative', left: '13px' }} />}
//               >
//                 <Menu.Item key="logins">
//                   <NavLink to="/Logins/LoginInfo"><LoginOutlined className="text-[18px]" /></NavLink>
//                 </Menu.Item>
//               </Menu.SubMenu>
//             )}
//             {localStorage.getItem('emp_role_id') == 5 && (
//               <>
//                 <Menu.Item key="employee">
//                   <NavLink to="/employee"><FaUserFriends style={{ fontSize: '18px' }} /></NavLink>
//                 </Menu.Item>
//                 <Menu.Item key="employeerate">
//                   <NavLink to="/employeerate"><FaCreditCard className="text-[16px]" /></NavLink>
//                 </Menu.Item>
//               </>
//             )}
//           </Menu>
//         </ul>
//       )}
//     </aside>
//   );
// };


// src/components/constants/Sidebar.js
// Restyled sidebar matching the new dashboard design. Permission logic is unchanged:
// items render only when api/Roles/GetPermissionsByRoleId grants their module_key.

import { useEffect, useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import {
  FiGrid, FiFileText, FiCalendar, FiUsers, FiCheck, FiBarChart2, FiSettings,
  FiBriefcase, FiFolder, FiUser, FiShield, FiLogIn, FiUserCheck, FiCreditCard,
  FiChevronDown, FiMenu, FiX,
} from "react-icons/fi";
import { fetchPermissions, fetchPendingApprovalsCount } from "../modules/dashboardApi";

// Route groups (absolute paths so they resolve the same from any page)
const SETTINGS_ROUTES = ["/Settings/Clients", "/Settings/projects", "/users", "/role"];

const linkBase =
  "relative flex items-center gap-3 min-h-[44px] rounded-[10px] text-[14px] no-underline transition-colors box-border";
const linkIdle = "text-[#3D4555] hover:bg-[#EEF3FC] hover:text-[#164AA6]";
const linkActive = "bg-[#E3ECFB] text-[#164AA6] font-semibold";

const NavItem = ({ to, icon: Icon, label, collapsed, badge = 0, nested = false }) => (
  <NavLink
    to={to}
    title={collapsed ? label : undefined}
    aria-label={collapsed ? label : undefined}
    className={({ isActive }) =>
      [
        linkBase,
        isActive ? linkActive : linkIdle,
        collapsed ? "justify-center px-0" : nested ? "pl-[42px] pr-[14px] min-h-[40px] text-[13px]" : "px-[14px]",
      ].join(" ")
    }
  >
    <Icon aria-hidden="true" className={`shrink-0 ${nested ? "text-[16px]" : "text-[18px]"}`} />
    {!collapsed && <span className="truncate">{label}</span>}
    {badge > 0 &&
      (collapsed ? (
        <span aria-hidden="true" className="absolute top-2 right-3 w-2 h-2 rounded-full bg-[#1D5FD1]" />
      ) : (
        <span className="ml-auto bg-[#1D5FD1] text-white text-[11px] font-semibold rounded-full px-2 py-0.5">
          {badge}
        </span>
      ))}
  </NavLink>
);

const NavGroup = ({ icon: Icon, label, open, active, collapsed, onToggle, children }) => (
  <div className="flex flex-col gap-1">
    <button
      type="button"
      onClick={onToggle}
      aria-expanded={open}
      title={collapsed ? label : undefined}
      aria-label={collapsed ? label : undefined}
      className={[
        linkBase,
        "w-full border-0 bg-transparent cursor-pointer text-left font-[inherit]",
        // highlight the parent only when the active child is hidden
        active && (!open || collapsed) ? linkActive : linkIdle,
        collapsed ? "justify-center px-0" : "px-[14px]",
      ].join(" ")}
    >
      <Icon aria-hidden="true" className="shrink-0 text-[18px]" />
      {!collapsed && (
        <>
          <span className="truncate">{label}</span>
          <FiChevronDown aria-hidden="true" className={`ml-auto transition-transform ${open ? "rotate-180" : ""}`} />
        </>
      )}
    </button>
    {open && !collapsed && children}
  </div>
);

/**
 * @param {Function} setsidebor     parent callback, receives isDrawerOpen (unchanged contract)
 * @param {number}   approvalCount  optional override for the Approvals badge; otherwise fetched
 */
export const Sidebar = ({ Emp_role, setsidebor, approvalCount }) => {
  const location = useLocation();
  const [isDrawerOpen, setIsDrawerOpen] = useState(true);
  const [permissions, setPermissions] = useState({}); // { dashboard: true, activity_card: true, ... }
  const [permLoading, setPermLoading] = useState(true);
  const [settingsOpen, setSettingsOpen] = useState(false);
  const [pendingApprovals, setPendingApprovals] = useState(0);

  const roleId = Number(localStorage.getItem("emp_role_id"));
  const path = location.pathname.toLowerCase();
  const settingsActive = SETTINGS_ROUTES.some((r) => path.startsWith(r.toLowerCase()));

  // ── 1. Fetch permissions once on mount ─────────────────────────────
  useEffect(() => {
    const empRoleId = localStorage.getItem("emp_role_id");
    if (!empRoleId) { setPermLoading(false); return; }
    fetchPermissions(empRoleId)
      .then(setPermissions)
      .catch((err) => console.error("Failed to load sidebar permissions:", err))
      .finally(() => setPermLoading(false));
  }, []);

  // ── 1b. Approvals badge (only if user can see Approvals) ───────────
  useEffect(() => {
    if (!permissions.approvals || approvalCount != null) return;
    fetchPendingApprovalsCount(localStorage.getItem("employee_id") || "").then(setPendingApprovals);
  }, [permissions.approvals, approvalCount, location.pathname]); // refresh on navigation

  // ── 2. Auto-open Settings when landing on one of its pages ─────────
  useEffect(() => {
    if (settingsActive) setSettingsOpen(true);
  }, [settingsActive]);

  useEffect(() => {
    setsidebor?.(isDrawerOpen);
  }, [isDrawerOpen, setsidebor]);

  const can = (key) => !!permissions[key];
  const collapsed = !isDrawerOpen;

  // In collapsed mode a group click expands the drawer and opens the group
  const toggleSettings = () => {
    if (collapsed) {
      setIsDrawerOpen(true);
      setSettingsOpen(true);
    } else setSettingsOpen((o) => !o);
  };

  const asideClass = [
    "sticky top-0 h-screen shrink-0 bg-white border-r border-[#E6E9EF] box-border",
    "flex flex-col gap-7 py-6 overflow-y-auto overflow-x-hidden transition-[width] duration-200",
    isDrawerOpen ? "w-[232px] px-4" : "w-[72px] px-3",
  ].join(" ");

  return (
    <aside aria-label="Main" className={asideClass} style={{ fontFamily: "'Poppins', system-ui, sans-serif" }}>
      {/* Brand + toggle */}
      <div className={`flex items-center gap-2.5 ${collapsed ? "flex-col" : "px-1.5"}`}>
        <div aria-hidden="true"
          className="w-9 h-9 shrink-0 rounded-[10px] bg-[#1D5FD1] text-white flex items-center justify-center font-bold text-[13px]">
          RCK
        </div>
        {isDrawerOpen && (
          <div className="flex flex-col leading-[1.1] min-w-0">
            <span className="font-bold text-[16px] text-[#0F172A] truncate">RCK Techiees</span>
            <span className="text-[12px] text-[#5B6474]">Timesheet</span>
          </div>
        )}
        <button
          type="button"
          onClick={() => setIsDrawerOpen((o) => !o)}
          aria-label={isDrawerOpen ? "Collapse sidebar" : "Expand sidebar"}
          aria-expanded={isDrawerOpen}
          className={`${isDrawerOpen ? "ml-auto" : ""} w-8 h-8 shrink-0 flex items-center justify-center rounded-lg border border-[#E6E9EF] bg-white text-[#5B6474] hover:text-[#1D5FD1] hover:border-[#1D5FD1] cursor-pointer`}
        >
          {isDrawerOpen ? <FiX className="text-[16px]" /> : <FiMenu className="text-[16px]" />}
        </button>
      </div>

      {permLoading ? (
        <div className="flex flex-col gap-2" aria-busy="true" aria-label="Loading menu">
          {Array.from({ length: 6 }).map((_, i) => (
            <div key={i} className="h-[44px] rounded-[10px] bg-[#F1F3F7] animate-pulse" />
          ))}
        </div>
      ) : (
        <nav className="flex flex-col gap-1">
          {can("dashboard") && <NavItem to="/dashboard" icon={FiGrid} label="Dashboard" collapsed={collapsed} />}
          {can("activity_card") && <NavItem to="/timesheets" icon={FiFileText} label="Activity Card" collapsed={collapsed} />}
          {can("my_activities") && <NavItem to="/my-workitems" icon={FiCalendar} label="My Activities" collapsed={collapsed} />}
          {can("teams_activities") && <NavItem to="/teams-activities" icon={FiUsers} label="Teams Activities" collapsed={collapsed} />}
          {can("approvals") && (
            <NavItem to="/Approvals" icon={FiCheck} label="Approvals" collapsed={collapsed} badge={approvalCount ?? pendingApprovals} />
          )}
          {can("reports") && <NavItem to="/reports" icon={FiBarChart2} label="Reports" collapsed={collapsed} />}

          {can("settings") && (
            <NavGroup icon={FiSettings} label="Settings" open={settingsOpen} active={settingsActive}
              collapsed={collapsed} onToggle={toggleSettings}>
              {can("clients") && <NavItem nested to="/Settings/Clients" icon={FiBriefcase} label="Clients" collapsed={collapsed} />}
              {can("projects") && <NavItem nested to="/Settings/projects" icon={FiFolder} label="Projects" collapsed={collapsed} />}
              {can("users") && <NavItem nested to="/users" icon={FiUser} label="Users" collapsed={collapsed} />}
              {can("role") && <NavItem nested to="/role" icon={FiShield} label="Role" collapsed={collapsed} />}
            </NavGroup>
          )}

          {/* Not in the permissions table — still role-gated as before */}
          {(roleId === 4 || roleId === 5) && (
            <NavItem to="/Logins/LoginInfo" icon={FiLogIn} label="Login Info" collapsed={collapsed} />
          )}
          {roleId === 5 && (
            <>
              <NavItem to="/employee" icon={FiUserCheck} label="Employee" collapsed={collapsed} />
              <NavItem to="/employeerate" icon={FiCreditCard} label="Rate Card" collapsed={collapsed} />
            </>
          )}
        </nav>
      )}
    </aside>
  );
};